import { useRef, useState } from "react";

const METHODS = [
  { name: "Send Money Bkash", key: "bkash", icon: "/assets/images/bkash.png", cashback: true },
  { name: "Send Money Nagad", key: "nagad", icon: "/assets/images/nagad.png", cashback: true },
  { name: "NAGAD", key: "nagad", icon: "/assets/images/nagad.png" },
];

const matchesMethod = (bank, key) => {
  const name = bank.bank_name?.toLowerCase() || "";
  return name.includes(key) || (key === "nagad" && name.includes("nadad"));
};

export default function ReferenceDepositGuide({ banks, onSelect, onApply, setTab }) {
  const [method, setMethod] = useState(0);
  const [amount, setAmount] = useState("");
  const [channel, setChannel] = useState(0);
  const guide = useRef(null);
  const configuredBank = banks.find(bank => matchesMethod(bank, METHODS[method].key));
  const selectMethod = index => {
    setMethod(index);
    setChannel(0);
    const bank = banks.find(bank => matchesMethod(bank, METHODS[index].key));
    if (bank) onSelect(bank._id);
  };
  return <section className="reference-deposit" aria-label="Deposit">
    <nav className="reference-deposit-methods" aria-label="Payment methods">
      {METHODS.map((item, index) => <button key={item.name} type="button" className={method === index ? "active" : ""} aria-pressed={method === index} onClick={() => selectMethod(index)}>
        <img src={item.icon} alt="" /><span>{item.name}{item.cashback && <small>Cashback 2%</small>}</span>
      </button>)}
    </nav>
    <div className="reference-deposit-main">
      <header><span className="reference-deposit-title">Deposit Info</span><div>
        <button type="button" onClick={() => setTab("accountRecord")}>▤ &nbsp; Deposit History</button>
        <button type="button" onClick={() => guide.current?.scrollIntoView({ block: "nearest", behavior: "smooth" })}>ⓘ &nbsp; How to Deposit?</button>
      </div></header>
      <div className="reference-deposit-body">
        <span className="reference-deposit-channel-title">রিচার্জ চ্যানেল {channel === 0 ? "১" : channel === 1 ? "৪" : "২০"}</span>
        <div className="reference-deposit-channels" role="group" aria-label="Recharge channels">
          {["১", "৪", "২০"].map((number, index) => <button type="button" key={number} className={channel === index ? "active" : ""} aria-pressed={channel === index} onClick={() => setChannel(index)}><b>👍</b><small>Cashback 2%</small><span>{index === 1 ? "ডিপোজিট চ্যানেল" : "রিচার্জ চ্যানেল"} {number}</span></button>)}
        </div>
        <img ref={guide} className="reference-deposit-guide" src="/assets/chorki/deposit-guide.svg" alt="Deposit guide: copy the account number from your deposit application, select Send Money in your payment app, then enter the amount and save your transaction ID." />
        <div className="reference-deposit-amounts"><span>Deposit Amounts：</span><div><div className="reference-deposit-presets">{[100,200,500,1000,3000,5000,10000,25000,50000].map(value => <button type="button" key={value} className={Number(amount) === value ? "active" : ""} onClick={() => setAmount(String(value))}>{value.toLocaleString("en-US")}</button>)}</div><input aria-label="Deposit Amounts" type="number" min="100" max="50000" placeholder="Deposit Amounts" value={amount} onChange={event => setAmount(event.target.value)} /><p>Deposit Limit： ৳ 100 - ৳ 50,000</p></div></div>
      </div>
      <footer><button type="button" onClick={() => { if (configuredBank) onSelect(configuredBank._id); onApply(amount); }}>Apply for Deposit</button></footer>
    </div>
  </section>;
}
